/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSitesP1ByIdIntervenant } from '../fn/site-intervenant-controller/get-sites-p-1-by-id-intervenant';
import { GetSitesP1ByIdIntervenant$Params } from '../fn/site-intervenant-controller/get-sites-p-1-by-id-intervenant';
import { SiteIntervenantDto } from '../models/site-intervenant-dto';

/**
 * site intervenant.
 */
@Injectable({ providedIn: 'root' })
export class SiteIntervenantControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSitesP1ByIdIntervenant()` */
  static readonly GetSitesP1ByIdIntervenantPath = '/v1/site-intervenant/p1/by-intervenant/{idIntervenant}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSitesP1ByIdIntervenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSitesP1ByIdIntervenant$Response(
    params: GetSitesP1ByIdIntervenant$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<SiteIntervenantDto>> {
    return getSitesP1ByIdIntervenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSitesP1ByIdIntervenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSitesP1ByIdIntervenant(
    params: GetSitesP1ByIdIntervenant$Params,
    context?: HttpContext
  ): Observable<SiteIntervenantDto> {
    return this.getSitesP1ByIdIntervenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<SiteIntervenantDto>): SiteIntervenantDto => r.body)
    );
  }
}
